import { createSelector } from 'reselect';

import { Question } from '../../types/question';
import { RootState } from '../root-reducer';
import { QuizValues, Step, StepLayouts } from './types';

const currentStepSelector = (state: RootState) => state.quizState.currentStep;
const answersSelector = (state: RootState) => state.quizState.answers;
const currentQuestionNumberSelector = (state: RootState) => state.quizState.currentQuestionNumber;

export const answeredQuestionIndexSelector = createSelector(
  currentStepSelector,
  answersSelector,
  currentQuestionNumberSelector,
  (currentStep: Step, answers: QuizValues, currentQuestionNumber: number | null): number | null => {
    if (currentQuestionNumber !== null) {
      return currentQuestionNumber;
    }
    if (currentStep.questions && answers) {
      const index = currentStep.questions.findIndex((question) => answers[question.name]);
      return index < 0 ? null : index;
    }
    return null;
  },
);

export const currentQuestionsSelector = createSelector(
  currentStepSelector,
  currentQuestionNumberSelector,
  answeredQuestionIndexSelector,
  (step: Step, currentIndex: null | number, answeredIndex: null | number): Question[] => {
    return step.layout === StepLayouts.COMPLEX ? [step.questions[currentIndex || answeredIndex || 0]] : step.questions;
  },
);

//TODO: rework this
function getInitialValues(step: Step) {
  if (!step) {
    return null;
  }
  return step.questions.reduce((acc, el) => {
    if (el.type === 'options') {
      acc[el.name] = [];
    } else {
      acc[el.name] = '';
    }
    return acc;
  }, {});
}

export const initialValuesSelector = createSelector(currentStepSelector, getInitialValues);

export const stepImageSelector = createSelector(currentStepSelector, (step: Step) => {
  return step.stepImages?.[0]?.image?.url;
});
